var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameCant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM32 61.5C48.2924 61.5 61.5 48.2924 61.5 32C61.5 15.7076 48.2924 2.5 32 2.5C15.7076 2.5 2.5 15.7076 2.5 32C2.5 48.2924 15.7076 61.5 32 61.5Z",
    fill: "#current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30.1146L38.6 23.5146L40.4853 25.4L33.8853 32L40.4853 38.6L38.6 40.4853L32 33.8853L25.4 40.4853L23.5146 38.6L30.1146 32L23.5146 25.4L25.4 23.5146L32 30.1146Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameCant);
export default __webpack_public_path__ + "static/media/game-cant.e50a5cc72ca7d5e2a3ffb16e70d89f8d.svg";
export { ForwardRef as ReactComponent };